    (function(){
      if (window.WubsWishlist) return;

      var ROOT = document.querySelector('[data-wubs-wl-root]');
      if (!ROOT) return;

      var GRID  = ROOT.querySelector('[data-wubs-wl-grid]');
      var EMPTY = ROOT.querySelector('[data-wubs-wl-empty]');
      var PANEL = ROOT.querySelector('.wubs-wl__panel');

      var TEXT = {
        added: ROOT.getAttribute('data-wubs-wl-added') || '',
        removed: ROOT.getAttribute('data-wubs-wl-removed') || '',
        openProduct: ROOT.getAttribute('data-wubs-wl-open-product') || '',
        remove: ROOT.getAttribute('data-wubs-wl-remove') || '',
        addToCart: ROOT.getAttribute('data-wubs-wl-add-to-cart') || '',
        unavailable: ROOT.getAttribute('data-wubs-wl-unavailable') || '',
        product: ROOT.getAttribute('data-wubs-wl-product') || ''
      };

      var TOAST = ROOT.querySelector('[data-wubs-wl-toast]');
      var TOAST_TXT = ROOT.querySelector('[data-wubs-wl-toast-text]');

      function customerId(){
        return ROOT.getAttribute('data-wubs-wl-customer') || '';
      }

      function keyFor(cid){
        return cid ? ('wubs_wishlist_v1_c' + cid) : 'wubs_wishlist_v1_guest';
      }

      function safeParse(raw){
        try{ return JSON.parse(raw); }catch(e){ return null; }
      }

      function readRawList(k){
        var raw = localStorage.getItem(k);
        if(!raw) return [];
        var parsed = safeParse(raw);
        if (Array.isArray(parsed)) return parsed;
        if (parsed && Array.isArray(parsed.items)) return parsed.items;
        return [];
      }

      function normalizeEntry(x){
        if (x == null) return null;

        if (typeof x === 'number' || typeof x === 'string'){
          var n = Number(x);
          if(!n || isNaN(n)) return null;
          return { id: n };
        }

        if (typeof x === 'object'){
          var id = Number(x.id || x.variantId || x.variant_id);
          if(!id || isNaN(id)) return null;
          return {
            id: id,
            handle: (x.handle || x.product_handle || ''),
            url: (x.url || ''),
            img: (x.img || x.image || ''),
            title: (x.title || ''),
            vendor: (x.vendor || '')
          };
        }

        return null;
      }

      function dedupeEntries(arr){
        var out = [];
        var seen = {};
        for (var i=0;i<arr.length;i++){
          var e = normalizeEntry(arr[i]);
          if(!e) continue;
          var k = String(e.id);
          if(seen[k]) continue;
          seen[k] = true;
          out.push(e);
        }
        return out;
      }

      function getEntriesFromKey(k){
        return dedupeEntries(readRawList(k));
      }

      function getEntries(){
        return getEntriesFromKey(keyFor(customerId()));
      }

      function getIds(entries){
        var out = [];
        for (var i=0;i<entries.length;i++){
          out.push(Number(entries[i].id));
        }
        return out;
      }

      function syncBadges(count){
        var badges = document.querySelectorAll('[data-wubs-wl-count]');
        for (var i=0;i<badges.length;i++){
          var b = badges[i];
          if (count > 0){
            b.hidden = false;
            b.textContent = String(count);
          } else {
            b.hidden = true;
            b.textContent = '0';
          }
        }
      }

      function syncToggles(entries){
        var ids = getIds(entries);
        var set = {};
        for (var i=0;i<ids.length;i++) set[String(ids[i])] = true;

        var toggles = document.querySelectorAll('[data-wubs-wl-toggle]');
        for (var j=0;j<toggles.length;j++){
          var el = toggles[j];
          var id = Number(el.getAttribute('data-wubs-wl-toggle'));
          var active = !!set[String(id)];
          el.classList.toggle('is-active', active);
          el.setAttribute('aria-pressed', active ? 'true' : 'false');
        }
      }

      function setEntries(entries){
        entries = dedupeEntries(entries).slice(0, 300);
        try{
          localStorage.setItem(keyFor(customerId()), JSON.stringify({ items: entries, updatedAt: Date.now() }));
        }catch(e){}

        syncBadges(entries.length);
        syncToggles(entries);
        window.dispatchEvent(new CustomEvent('wubs-wishlist-change', { detail: { items: entries, count: entries.length } }));
      }

      function mergeGuestToCustomerIfNeeded(){
        var cid = customerId();
        if (!cid) return;

        var flag = 'wubs_wl_merged_' + cid;
        if (localStorage.getItem(flag) === '1') return;

        var guest = getEntriesFromKey('wubs_wishlist_v1_guest');
        if (guest.length){
          var cur = getEntries();
          setEntries(cur.concat(guest));
          try{ localStorage.removeItem('wubs_wishlist_v1_guest'); }catch(e){}
        }
        try{ localStorage.setItem(flag, '1'); }catch(e){}
      }

      function open(){
        if (open._raf) cancelAnimationFrame(open._raf);
        window.clearTimeout(close._t);

        ROOT.classList.remove('is-toast');

        if (ROOT.classList.contains('is-open')){
          ROOT.setAttribute('aria-hidden', 'false');
          document.documentElement.style.overflow = 'hidden';
          render();
          try{ if(PANEL) PANEL.focus(); }catch(e){}
          return;
        }

        ROOT.classList.remove('is-closing');
        ROOT.classList.add('is-mounted');
        ROOT.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';

        void ROOT.offsetWidth;

        open._raf = requestAnimationFrame(function(){
          ROOT.classList.add('is-open');
          try{ if(PANEL) PANEL.focus(); }catch(e){}
        });

        render();
      }

      function close(){
        if(!ROOT.classList.contains('is-open')) return;

        if (open._raf) cancelAnimationFrame(open._raf);

        ROOT.classList.remove('is-open');
        ROOT.classList.add('is-closing');
        ROOT.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';

        window.clearTimeout(close._t);
        close._t = window.setTimeout(function(){
          ROOT.classList.remove('is-closing');
          ROOT.classList.remove('is-mounted');
        }, 260);
      }

      function hardClose(){
        if (open._raf) cancelAnimationFrame(open._raf);
        window.clearTimeout(close._t);
        window.clearTimeout(hideToast._t);

        ROOT.classList.remove('is-open');
        ROOT.classList.remove('is-closing');
        ROOT.classList.remove('is-toast');
        ROOT.classList.remove('is-mounted');
        ROOT.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
      }

      function showToast(kind, entry){
        if(!TOAST || ROOT.classList.contains('is-open')) return;

        var title = (entry && entry.title) ? String(entry.title) : '';
        var msg = (kind === 'removed') ? TEXT.removed : TEXT.added;
        if(title) msg = msg + ': ' + title;

        if(TOAST_TXT) TOAST_TXT.textContent = msg;

        ROOT.classList.add('is-mounted');
        ROOT.classList.add('is-toast');

        window.clearTimeout(showToast._t);
        showToast._t = window.setTimeout(hideToast, 2400);
      }

      function hideToast(){
        ROOT.classList.remove('is-toast');

        window.clearTimeout(hideToast._t);
        hideToast._t = window.setTimeout(function(){
          if(!ROOT.classList.contains('is-open') && !ROOT.classList.contains('is-closing')){
            ROOT.classList.remove('is-mounted');
          }
        }, 200);
      }

      function formatMoney(cents){
        try{
          if(window.Shopify && typeof window.Shopify.formatMoney === 'function'){
            return window.Shopify.formatMoney(cents, ROOT.getAttribute('data-money-format'));
          }
        }catch(e){}

        var value = (Number(cents) || 0) / 100;
        try{
          return new Intl.NumberFormat(ROOT.getAttribute('data-locale') || undefined, {
            style: 'currency',
            currency: ROOT.getAttribute('data-currency') || 'SEK',
            maximumFractionDigits: 0
          }).format(value);
        }catch(e){
          return String(value);
        }
      }

      function escapeHtml(value){
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function withWidth(src, w){
        if(!src) return '';
        var s = String(src);
        if (s.indexOf('width=') > -1) return s;
        return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + String(w || 900);
      }

      function handleFromProductUrl(url){
        try{
          var m = String(url || '').match(/\/products\/([^\/\?\#]+)/);
          return m && m[1] ? m[1] : '';
        }catch(e){ return ''; }
      }

      function openQuickAdd(handle, url, variantId){
        var opened = false;

        try{
          document.dispatchEvent(new CustomEvent('wubs:quick-add-open', { detail: { handle: handle, url: url, variantId: variantId } }));
          opened = true;
        }catch(e){}

        if(!opened && window.wubsQuickAddOpen){
          try{
            for(var k in window.wubsQuickAddOpen){
              if(typeof window.wubsQuickAddOpen[k] === 'function'){
                window.wubsQuickAddOpen[k](handle, { url: url, variantId: variantId });
                opened = true;
                break;
              }
            }
          }catch(e){}
        }

        if(!opened){
          if(url) window.location.href = url;
          else if(handle) window.location.href = '/products/' + handle + '?variant=' + String(variantId || '');
          else window.location.href = '/cart';
        }

        return opened;
      }

      var variantCache = {};
      function fetchVariant(variantId){
        var id = String(variantId);
        if (variantCache[id]) return variantCache[id];

        variantCache[id] = fetch('/variants/' + id + '.js', { credentials:'same-origin' })
          .then(function(r){ if(!r.ok) throw new Error('variant_fetch'); return r.json(); })
          .catch(function(){ return null; });

        return variantCache[id];
      }

      var productCache = {};
      function fetchProduct(handle){
        handle = String(handle || '').trim();
        if(!handle) return Promise.resolve(null);
        if (productCache[handle]) return productCache[handle];

        productCache[handle] = fetch('/products/' + handle + '.js', { credentials:'same-origin' })
          .then(function(r){ if(!r.ok) throw new Error('product_fetch'); return r.json(); })
          .catch(function(){ return null; });

        return productCache[handle];
      }

      function skeletonItem(entry){
        var id = Number(entry.id);
        return '' +
          '<div class="wubs-wl__item" data-wubs-wl-item="' + id + '">' +
            '<a class="wubs-wl__media" href="#" aria-label="' + escapeHtml(TEXT.openProduct) + '">' +
              '<img class="wubs-wl__img" alt="" loading="lazy" />' +
              '<button class="wubs-wl__rm" type="button" data-wubs-wl-remove="' + id + '" aria-label="' + escapeHtml(TEXT.remove) + '">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
                  '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
                '</svg>' +
              '</button>' +
            '</a>' +
            '<div class="wubs-wl__meta">' +
              '<div class="wubs-wl__vendor"></div>' +
              '<a class="wubs-wl__name" href="#"></a>' +
              '<div class="wubs-wl__price"></div>' +
              '<button class="wubs-wl__atc" type="button" data-wubs-wl-atc="' + id + '">' + escapeHtml(TEXT.addToCart) + '</button>' +
            '</div>' +
          '</div>';
      }

      function render(){
        if (!GRID) return;

        var entries = getEntries();

        if (!entries.length){
          if (EMPTY) EMPTY.hidden = false;
          GRID.innerHTML = '';
          return;
        }

        if (EMPTY) EMPTY.hidden = true;

        var html = '';
        for (var i=0;i<entries.length;i++){
          html += skeletonItem(entries[i]);
        }
        GRID.innerHTML = html;

        for (var j=0;j<entries.length;j++){
          (function(entry){
            var variantId = Number(entry.id);

            fetchVariant(variantId).then(function(v){
              try{
                var el = GRID.querySelector('[data-wubs-wl-item="' + variantId + '"]');
                if(!el) return;

                var mediaLink = el.querySelector('.wubs-wl__media');
                var nameLink  = el.querySelector('.wubs-wl__name');
                var img       = el.querySelector('.wubs-wl__img');

                if(!v){
                  if (mediaLink) mediaLink.href = '/cart?variant=' + variantId;
                  if (nameLink){
                    nameLink.href = '/cart?variant=' + variantId;
                    nameLink.textContent = TEXT.unavailable;
                  }
                  el.querySelector('.wubs-wl__vendor').textContent = '';
                  el.querySelector('.wubs-wl__price').textContent = '';
                  var atc0 = el.querySelector('.wubs-wl__atc');
                  if(atc0) atc0.disabled = true;
                  return;
                }

                var handle = (entry.handle || v.product_handle || v.handle || '');
                var url = entry.url || '';
                if(!url){
                  if(handle) url = '/products/' + handle + '?variant=' + variantId;
                  else url = '/cart?variant=' + variantId;
                }

                el.setAttribute('data-wubs-wl-handle', handle || '');
                el.setAttribute('data-wubs-wl-url', url || '');

                if (mediaLink) mediaLink.href = url;
                if (nameLink){
                  nameLink.href = url;
                  nameLink.textContent = entry.title || v.product_title || v.name || TEXT.product;
                }

                var vendorNode = el.querySelector('.wubs-wl__vendor');
                if (vendorNode) vendorNode.textContent = entry.vendor || v.vendor || '';

                var priceNode = el.querySelector('.wubs-wl__price');
                if (priceNode) priceNode.textContent = formatMoney(v.price);

                var atc = el.querySelector('.wubs-wl__atc');
                if (atc) atc.disabled = !v.available;

                var imgSrc = '';
                if (entry.img) imgSrc = entry.img;
                if (!imgSrc && v.featured_image && v.featured_image.src) imgSrc = v.featured_image.src;
                if (!imgSrc && typeof v.featured_image === 'string') imgSrc = v.featured_image;

                imgSrc = withWidth(imgSrc, 900);

                if (img && imgSrc){
                  img.src = imgSrc;
                  img.alt = (entry.title || v.product_title || TEXT.product);
                  return;
                }

                if (img){
                  var h = handle || handleFromProductUrl(url);
                  fetchProduct(h).then(function(p){
                    if(!p || !img) return;
                    var src = p.featured_image || (p.images && p.images[0]) || '';
                    src = withWidth(src, 900);
                    if(src){
                      img.src = src;
                      img.alt = p.title || (entry.title || v.product_title || TEXT.product);
                    }
                  });
                }
              }catch(e){}
            });
          })(entries[j]);
        }
      }

      async function refreshDawnSections(){
        try{
          var res = await fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials:'same-origin' });
          if(!res.ok) return;
          var data = await res.json();

          if(data['cart-icon-bubble']){
            var bubble = document.querySelector('#cart-icon-bubble');
            if(bubble){
              var tmpB = document.createElement('div');
              tmpB.innerHTML = data['cart-icon-bubble'];
              var newBubble = tmpB.querySelector('#cart-icon-bubble');
              if(newBubble) bubble.replaceWith(newBubble);
            }
          }

          if(data['cart-drawer']){
            var drawer = document.querySelector('cart-drawer');
            if(drawer){
              var tmpD = document.createElement('div');
              tmpD.innerHTML = data['cart-drawer'];
              var newDrawer = tmpD.querySelector('cart-drawer');
              if(newDrawer) drawer.replaceWith(newDrawer);
            }
          }
        }catch(e){}
      }

      async function addToCart(variantId, btn){
        if(!variantId) return;

        var item = null;
        try{ item = btn && btn.closest ? btn.closest('[data-wubs-wl-item]') : null; }catch(e){}
        var handle = item ? (item.getAttribute('data-wubs-wl-handle') || '') : '';
        var url = item ? (item.getAttribute('data-wubs-wl-url') || '') : '';

        if(!handle){
          try{
            var v = await fetchVariant(variantId);
            if(v && v.product_handle) handle = String(v.product_handle);
          }catch(e){}
        }

        if(handle){
          try{
            var p = await fetchProduct(handle);
            if(p && p.variants && p.variants.length > 1){
              hardClose();
              openQuickAdd(handle, url, variantId);
              return;
            }
          }catch(e){}
        }

        if(btn){
          btn.classList.add('is-loading');
          btn.setAttribute('aria-busy','true');
        }

        try{
          var res = await fetch('/cart/add.js', {
            method:'POST',
            headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
            credentials:'same-origin'
          });
          if(!res.ok) throw new Error('add_failed');

          await refreshDawnSections();

          var drawer = document.querySelector('cart-drawer');
          if(drawer && typeof drawer.open === 'function'){
            drawer.open();
          }
        }catch(e){
          window.location.href = '/cart';
        }finally{
          if(btn){
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
          }
        }
      }

      function add(entryOrId){
        var entry = normalizeEntry(entryOrId);
        if(!entry) return false;

        var entries = getEntries();
        for (var i=0;i<entries.length;i++){
          if (Number(entries[i].id) === Number(entry.id)) return false;
        }
        entries.unshift(entry);
        setEntries(entries);
        return true;
      }

      function remove(id){
        id = Number(id);
        var entries = getEntries();
        var out = [];
        for (var i=0;i<entries.length;i++){
          if (Number(entries[i].id) !== id) out.push(entries[i]);
        }
        setEntries(out);
        render();
        return true;
      }

      function toggle(entryOrId){
        var entry = normalizeEntry(entryOrId);
        if(!entry) return null;

        var id = Number(entry.id);
        var entries = getEntries();

        var exists = false;
        for (var i=0;i<entries.length;i++){
          if (Number(entries[i].id) === id){ exists = true; break; }
        }

        if (exists){
          remove(id);
          return 'removed';
        } else {
          add(entry);
          return 'added';
        }
      }

      function clearAll(){
        setEntries([]);
        render();
      }

      document.addEventListener('click', function(e){
        var openBtn = e.target.closest('[data-wubs-wl-open]');
        if (openBtn){
          e.preventDefault();
          open();
          return;
        }

        var closeBtn = e.target.closest('[data-wubs-wl-close]');
        if (closeBtn){
          e.preventDefault();
          close();
          return;
        }

        var toastClose = e.target.closest('[data-wubs-wl-toast-close]');
        if (toastClose){
          e.preventDefault();
          hideToast();
          return;
        }

        var clearBtn = e.target.closest('[data-wubs-wl-clear]');
        if (clearBtn){
          e.preventDefault();
          clearAll();
          return;
        }

        var rmBtn = e.target.closest('[data-wubs-wl-remove]');
        if (rmBtn){
          e.preventDefault();
          remove(rmBtn.getAttribute('data-wubs-wl-remove'));
          return;
        }

        var atcBtn = e.target.closest('[data-wubs-wl-atc]');
        if (atcBtn){
          e.preventDefault();
          addToCart(atcBtn.getAttribute('data-wubs-wl-atc'), atcBtn);
          return;
        }

        var toggleBtn = e.target.closest('[data-wubs-wl-toggle]');
        if (toggleBtn){
          e.preventDefault();

          var entry = {
            id: toggleBtn.getAttribute('data-wubs-wl-toggle'),
            handle: toggleBtn.getAttribute('data-wubs-wl-handle') || '',
            url: toggleBtn.getAttribute('data-wubs-wl-url') || '',
            img: toggleBtn.getAttribute('data-wubs-wl-img') || '',
            title: toggleBtn.getAttribute('data-wubs-wl-title') || '',
            vendor: toggleBtn.getAttribute('data-wubs-wl-vendor') || ''
          };

          var res = toggle(entry);
          if(res) showToast(res, entry);
          return;
        }
      });

      document.addEventListener('keydown', function(e){
        if (!ROOT.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
      });

      mergeGuestToCustomerIfNeeded();

      var initial = getEntries();
      syncBadges(initial.length);
      syncToggles(initial);

      window.WubsWishlist = {
        open: open,
        close: close,
        render: render,
        add: add,
        remove: remove,
        toggle: toggle,
        clear: clearAll,
        get: getEntries
      };
    })();
